<template>


  <div class="wechat-tips" v-if="isWechat" id="weChat-mask">
    <img  src="../../assets/images/arrow.png" alt="">
    <span class="tips">请点击右上角选择在浏览器打开</span>
    <div class="tips-button" id="weChat-back-btn" @click="goBack">
      返回
    </div>
  </div>
</template>

<script>
import { downloadFileDirect } from "@/common/file.js";
import { ck } from "fire-wind-water";
export default {
  name: "weChatTip",
  data() {
    return {
      isWechat: window.$ua.isWeChat
    };
  },
  mounted() {
    window.$sk && window.$sk.loading.hide();
    const url = this.$route.query.downloadUrl;
    const fs = this.$route.query.fs;
    if (!this.isWechat && url) {
      if (fs !== "") {
        ck.cookie("fileSession", decodeURIComponent(fs), {
          domain: window.$sk.config.domain,
          path: "/"
        });
      }
      downloadFileDirect(url);
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
.weChatTips {
  position: relative;
  .page-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .weChat-mask {
    background-color: rgba(0, 0, 0, 0.8);
  }

  .arrow-up-container {
    position: absolute;
    top: 0;
    right: 20px;
    width: 200px;
    height: 200px;
  }

  .arrow-up-container img {
    max-width: 100%;
    max-height: 100%;
  }

  .weChat-window {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 500px;
    height: 350px;
    margin: 350px auto 0 auto;
    border: 5px dashed #fff;
    border-radius: 22vw;
    z-index: 20;
    font-size: 36px;
    color: #fff;
  }

  .weChat-window .link-close {
    right: auto;
    left: 20px;
  }

  .weChat-window p {
    line-height: 200%;
    text-align: center;
    letter-spacing: 1px;
  }

  .weChat-btn {
    display: block;
    width: 350px;
    padding: 12px;
    margin: 100px auto 0 auto;
    letter-spacing: 10px;
    text-align: center;
    font-size: 28px;
    background: none;
    outline: none;
  }

  .weChat-back-btn {
    border: 1px solid #fff;
    color: #fff;
  }
  .weChat-download {
    margin: 0 auto;
    display: block;
    width: 350px;
    padding: 12px;
    letter-spacing: 10px;
    text-align: center;
    font-size: 28px;
    background: none;
    outline: none;
  }

  .weChat-download-text {
    border: 1px solid #333;
    color: #333;
  }

  .weChat-download-text .txt-small {
    font-size: 18px;
    letter-spacing: 1px;
    padding: 4px 0;
  }
}
</style>
